import { motion } from "framer-motion";

export const Footer = () => (
  <footer
    data-testid="footer"
    className="bg-samatva-ink text-samatva-cream pt-24 pb-10 px-6 md:px-12 overflow-hidden"
  >
    <div className="max-w-[1400px] mx-auto">
      <div className="flex flex-col md:flex-row justify-between gap-12 mb-20">
        <div className="max-w-sm">
          <div className="flex items-center gap-3 mb-6">
            <img
              src="/samatva-logo.jpeg"
              alt="Samatva logo"
              className="w-12 h-12 rounded-full object-cover bg-samatva-cream"
            />
            <span className="font-serif text-xl tracking-[0.25em]">SAMATVA</span>
          </div>
          <p className="text-sm font-light leading-relaxed text-samatva-lavender/70">
            A holistic well-being community. Because health is an umbrella —
            and so are we.
          </p>
        </div>
        <div className="flex gap-16">
          <div>
            <p className="text-xs tracking-[0.3em] uppercase text-samatva-lilac mb-4">
              Explore
            </p>
            <ul className="space-y-2 text-sm font-light text-samatva-lavender/80">
              <li><a href="#pillars" data-testid="footer-link-pillars" className="hover:text-samatva-cream transition-colors duration-300">Pillars</a></li>
              <li><a href="#column" data-testid="footer-link-column" className="hover:text-samatva-cream transition-colors duration-300">Weekly Column</a></li>
              <li><a href="#vaarta" data-testid="footer-link-vaarta" className="hover:text-samatva-cream transition-colors duration-300">Vaarta Podcast</a></li>
              <li><a href="#join" data-testid="footer-link-join" className="hover:text-samatva-cream transition-colors duration-300">Join Us</a></li>
              <li><a href="/admin" data-testid="footer-link-admin" className="hover:text-samatva-cream transition-colors duration-300">Studio</a></li>
            </ul>
          </div>
          <div>
            <p className="text-xs tracking-[0.3em] uppercase text-samatva-lilac mb-4">
              Connect
            </p>
            <ul className="space-y-2 text-sm font-light text-samatva-lavender/80">
              <li><a href="mailto:hello@samatva.community" data-testid="footer-email-link" className="hover:text-samatva-cream transition-colors duration-300">hello@samatva.community</a></li>
              <li><a href="#join" data-testid="footer-instagram-link" className="hover:text-samatva-cream transition-colors duration-300">Instagram</a></li>
              <li><a href="#vaarta" data-testid="footer-youtube-link" className="hover:text-samatva-cream transition-colors duration-300">YouTube</a></li>
              <li><a href="#vaarta" data-testid="footer-spotify-link" className="hover:text-samatva-cream transition-colors duration-300">Spotify</a></li>
            </ul>
          </div>
        </div>
      </div>

      <motion.p
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
        className="font-serif font-light text-center text-[18vw] md:text-[12vw] leading-none text-transparent select-none"
        style={{ WebkitTextStroke: "1px rgba(201,175,228,0.35)" }}
      >
        समत्व
      </motion.p>

      <div className="mt-16 pt-6 border-t border-samatva-lilac/20 flex flex-col md:flex-row justify-between gap-3 text-xs font-light text-samatva-lavender/50">
        <span>© 2026 Samatva Community. All rights reserved.</span>
        <span>समत्वं योग उच्यते — Bhagavad Gita 2.48</span>
      </div>
    </div>
  </footer>
);
